import { useState, useEffect, useRef, useCallback } from 'react';

export function useIdleTimer(timeoutMs: number = 5000): { isIdle: boolean } {
  const [isIdle, setIsIdle] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const resetTimer = useCallback(() => {
    setIsIdle(false);
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setIsIdle(true), timeoutMs);
  }, [timeoutMs]);

  useEffect(() => {
    const events: Array<keyof DocumentEventMap> = [
      'mousemove',
      'mousedown',
      'keydown',
      'touchstart',
    ];

    timerRef.current = setTimeout(() => setIsIdle(true), timeoutMs);

    for (const event of events) {
      document.addEventListener(event, resetTimer, { passive: true });
    }

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      for (const event of events) {
        document.removeEventListener(event, resetTimer);
      }
    };
  }, [resetTimer, timeoutMs]);

  return { isIdle };
}
